import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import QuestionIcon from 'assets/svg/question-icon-blue.svg';
import { ExternalLinkButton } from 'components/buttons/LinkButton';
import { ROUTE_MESSENGER_SUPPORT } from 'navigation/config/routesConfig';

const Container = styled(ExternalLinkButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: ${theme.color.blue};
  margin-top: 18px;

  &:hover {
    opacity: 0.7;
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

const ContactSupportButton = () => {
  const { t } = useTranslation();
  return (
    <Container href={ROUTE_MESSENGER_SUPPORT} target='_blank' rel='noopener noreferrer'>
      <Icon src={QuestionIcon} />
      {t('contact-support')}
    </Container>
  );
};

export default ContactSupportButton;
